import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {API_ENDPOINT, getParts} from 'constant';
import {buildActionType} from 'action/apiResource';
import {Loader} from '../../components';
import {useLocation} from 'react-router-dom/cjs/react-router-dom.min';
import {toCamelCase} from 'service/utils';
import BuildConfig from '../../service/BuildConfig';

const LOGIN_SUCCESS = buildActionType(getParts(API_ENDPOINT.AUTH.LOGIN));

const AuthSuccess = () => {
  const dispatch = useDispatch();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');

  useEffect(() => {
    if (!token) {
      window.location.href = '/login';

      return;
    }

    fetch(`${BuildConfig.API_ENDPOINT}/me`, {
      headers     : {Authorization : `Bearer ${token}`},
      credentials : 'include'
    })
      .then(res => res.json())
      .then(data => {
        if (data.user) {
          const transformedData = toCamelCase(data);

          dispatch({
            type    : LOGIN_SUCCESS,
            payload : {
              data : {
                accessToken : token,
                user        : transformedData.user,
                firstLogin  : data.firstLogin
              }
            }
          });
          window.location.href = '/dashboard';
        } else {
          window.location.href = '/login';
        }
      })
      .catch(() => {
        window.location.href = '/login';
      });
  }, [dispatch, token]);

  return <Loader isLoading />;
};

AuthSuccess.displayName = 'AuthSuccess';
export default AuthSuccess;
